import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
} from "reactstrap";
import DefaultForm from "../common/defaultForm";
import { Link, Navigate, NavigateFunction, useNavigate } from "react-router-dom";
import Joi from "joi-browser";
import auth from "../services/authService";

interface LoginProps {
  history: NavigateFunction
}

class Login extends DefaultForm<LoginProps> {
  schema = {
    username: Joi.string().required().email().label("E-mail"),
    password: Joi.string().required().label("Senha"),
  };

  doSubmit = async () => {
    // TODO: move this try catch to service
    try {
      const { data } = this.state;
      const jwt = await auth.login(data.username, data.password);
      if (jwt) {
        //console.log("Login", { jwt });
        this.props.history("/gerenciamento");
      }

    } catch (ex) {
      console.log("login excepetion", ex)
      this.setState({ submitting: false });
      if (ex.response && ex.response.status === 400) {
        this.setState({ errors: ex.response.data });
      }
    }
  };

  componentDidMount() {
    console.log("login did mount", this.props);

  }

  state = {
    data: { username: "", password: "" },
    errors: {},
    ready: false,
    submitting: false,
  };
  render() {


    if (auth.isValid())
      return <Navigate to="/gerenciamento" replace />;


    return (
      <React.Fragment>
        <header className="background-home"></header>
        <div className="app flex-row align-items-center">
          <Container className="mt-5">
            <Row className="justify-content-center">
              <Col md="5">
                <Card color="success">
                  <CardHeader className="text-white text-center">
                    Login
                  </CardHeader>
                  <CardBody style={{ backgroundColor: "white" }}>
                    <Col md={{ size: "auto", offset: 1 }}>
                      <Form onSubmit={this.handleSubmit}>
                        <Row>
                          <Col md={11}>
                            {this.renderInput(
                              "username",
                              "E-mail",
                              "text",
                              false,
                              false,
                              true
                            )}
                            {this.renderInput(
                              "password",
                              "Senha",
                              "password",
                              false,
                              false,
                              true
                            )}
                            <Row>
                              <Col md="6">
                                {this.renderButton(
                                  "Entrar",
                                  "btn btn-success px-4"
                                )}
                              </Col>
                              {/* TODO: criar novo link de cadastro para o bolsista */}
                              {window.location.search.includes("bolsista") && (
                                <Col md="6" className="text-right">
                                  <Link
                                    className="d-inline-block mt-2 text-dark"
                                    style={{ textDecoration: "underline" }}
                                    to="/cadastro"
                                  >Cadastro
                                  </Link>
                                </Col>
                              )}
                            </Row>
                            <Row>
                              <Col>
                                <Link
                                  className="d-inline-block mt-2 text-dark"
                                  style={{ textDecoration: "underline" }}
                                  to="/changePassword?&mode=requesting"
                                >Esqueci minha senha
                                </Link>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default (props) => (
  <Login history={useNavigate()} />
);

